(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-main-darich"]) return;
  try {
    
  const qtyButtons = document.querySelectorAll('.darich-qty-btn');
  
  qtyButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const action = this.dataset.action;
      const line = this.dataset.line;
      const input = document.querySelector(`.darich-qty-input[data-line="${line}"]`);
      let qty = parseInt(input.value);

      if (action === 'increase') {
        qty++;
      } else if (action === 'decrease' && qty > 1) {
        qty--;
      }

      input.value = qty;
    });
  });

  const removeButtons = document.querySelectorAll('.darich-cart-item__remove');
  
  removeButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const line = this.dataset.line;
      const input = document.querySelector(`.darich-qty-input[data-line="${line}"]`);
      input.value = 0;
      this.closest('form').submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid-darich"] && !Shopify.designMode) return;
  try {
    
  class DarichCollectionFilters {
    constructor(container) {
      this.container = container;
      this.filterButtons = container.querySelectorAll('.darich-filter-btn');
      this.productCards = container.querySelectorAll('.darich-product-card');
      
      this.init();
    }
    
    init() {
      this.filterButtons.forEach(button => {
        button.addEventListener('click', (e) => this.handleFilterClick(e));
      });
    }
    
    handleFilterClick(e) {
      const button = e.currentTarget;
      const filter = button.getAttribute('data-filter');
      
      // Update active state
      this.filterButtons.forEach(btn => btn.classList.remove('darich-filter-btn--active'));
      button.classList.add('darich-filter-btn--active');
      
      // Filter products
      this.filterProducts(filter);
    }
    
    filterProducts(filter) {
      this.productCards.forEach(card => {
        const cardFilters = card.getAttribute('data-filter') || '';
        
        if (cardFilters.includes(filter)) {
          card.style.display = 'block';
        } else {
          card.style.display = 'none';
        }
      });
    }
  }
  
  // Initialize filters when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const collectionSections = document.querySelectorAll('.darich-collection');
    collectionSections.forEach(section => {
      new DarichCollectionFilters(section);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-main-darich"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sortSelect = document.getElementById('SortBy');
    
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });

      // Set current sort value
      const urlParams = new URLSearchParams(window.location.search);
      const sortBy = urlParams.get('sort_by');
      if (sortBy) {
        sortSelect.value = sortBy;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const menuToggle = document.querySelector('.darich-header__menu-toggle');
    const mobileMenu = document.querySelector('.darich-mobile-menu');
    const menuClose = document.querySelector('.darich-mobile-menu__close');
    const menuOverlay = document.querySelector('.darich-mobile-menu__overlay');
    const headerWrap = document.querySelector('.darich-header-wrap');

    // Adjust body padding for fixed header
    function adjustBodyPadding() {
      if (headerWrap) {
        const headerHeight = headerWrap.offsetHeight;
        document.body.style.paddingTop = headerHeight + 'px';
        // Also set CSS custom property for use in other components
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      }
    }

    // Call on load and resize with a slight delay to ensure accurate measurement
    setTimeout(adjustBodyPadding, 100);
    window.addEventListener('resize', adjustBodyPadding);
    window.addEventListener('load', adjustBodyPadding);

    // Mobile menu functionality
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function() {
        mobileMenu.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });

      if (menuClose) {
        menuClose.addEventListener('click', function() {
          mobileMenu.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }

      if (menuOverlay) {
        menuOverlay.addEventListener('click', function() {
          mobileMenu.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }
    }

    // Scroll detection for transparent header
    if (headerWrap) {
      function handleScroll() {
        if (window.scrollY > 50) {
          headerWrap.classList.add('scrolled');
        } else {
          headerWrap.classList.remove('scrolled');
        }
      }

      window.addEventListener('scroll', handleScroll);
      handleScroll(); // Check initial state
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel-darich"] && !Shopify.designMode) return;
  try {
    
  class HeroCarouselCards {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('.hero-carousel-cards__track');
      this.cards = section.querySelectorAll('.hero-carousel-cards__card');
      this.dots = section.querySelectorAll('.hero-carousel-cards__dot');
      this.prevButton = section.querySelector('.hero-carousel-cards__arrow--prev');
      this.nextButton = section.querySelector('.hero-carousel-cards__arrow--next');
      this.currentIndex = 0;
      this.autoplay = section.dataset.autoplay === 'true';
      this.autoplayDuration = parseInt(section.dataset.autoplayDuration) || 5000;
      this.autoplayTimer = null;

      this.init();
    }

    init() {
      if (this.cards.length <= 1) return;

      // Set initial active card
      this.cards[0].classList.add('active');

      // Arrow navigation
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.prev());
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.next());
      }

      // Dot navigation
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prev();
        if (e.key === 'ArrowRight') this.next();
      });

      // Touch/Swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      this.track.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.track.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe(touchStartX, touchEndX);
      }, { passive: true });

      // Autoplay
      if (this.autoplay) {
        this.startAutoplay();
        
        // Pause on hover
        this.section.addEventListener('mouseenter', () => this.stopAutoplay());
        this.section.addEventListener('mouseleave', () => this.startAutoplay());
      }

      // Initial position
      this.updateCarousel();
    }

    handleSwipe(startX, endX) {
      const difference = startX - endX;
      const threshold = 50;

      if (Math.abs(difference) > threshold) {
        if (difference > 0) {
          this.next();
        } else {
          this.prev();
        }
      }
    }

    goToSlide(index) {
      // Remove active class from current card and dot
      this.cards[this.currentIndex].classList.remove('active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove('active');
      }

      // Update index
      this.currentIndex = index;

      // Add active class to new card and dot
      this.cards[this.currentIndex].classList.add('active');
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.add('active');
      }

      // Update carousel position
      this.updateCarousel();

      // Reset autoplay
      if (this.autoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    updateCarousel() {
      const card = this.cards[this.currentIndex];
      const cardWidth = card.offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const offset = (this.currentIndex * (cardWidth + gap));
      
      // Center the active card
      const trackWrapper = this.section.querySelector('.hero-carousel-cards__track-wrapper');
      const wrapperWidth = trackWrapper.offsetWidth;
      const centerOffset = (wrapperWidth / 2) - (cardWidth / 2);
      
      this.track.style.transform = `translateX(${centerOffset - offset}px)`;
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.cards.length;
      this.goToSlide(nextIndex);
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.cards.length) % this.cards.length;
      this.goToSlide(prevIndex);
    }

    startAutoplay() {
      this.autoplayTimer = setInterval(() => {
        this.next();
      }, this.autoplayDuration);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  // Initialize carousel
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.hero-carousel-cards');
    carousels.forEach(carousel => new HeroCarouselCards(carousel));
  });

  // Reinitialize on Shopify theme editor events and window resize
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const carousel = event.target.querySelector('.hero-carousel-cards');
      if (carousel) new HeroCarouselCards(carousel);
    });
  }

  window.addEventListener('resize', () => {
    const carousels = document.querySelectorAll('.hero-carousel-cards');
    carousels.forEach(carousel => {
      const instance = carousel._carouselInstance;
      if (instance) instance.updateCarousel();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-darich"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Scroll-based image gallery
    const mainImageContainer = document.querySelector('.darich-product__main-image');
    const imageSlides = document.querySelectorAll('.darich-product__image-slide');
    const thumbnails = document.querySelectorAll('.darich-product__thumbnail');
    const indicators = document.querySelectorAll('.swipe-indicator');
    let currentIndex = 0;

    function scrollToImage(index) {
      if (index < 0 || index >= imageSlides.length) return;
      const slide = imageSlides[index];
      if (slide && mainImageContainer) {
        mainImageContainer.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth'
        });
      }
    }

    function updateActiveStates(index) {
      // Update thumbnails
      thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
      });
      
      // Update indicators
      indicators.forEach((indicator, i) => {
        indicator.classList.toggle('is-active', i === index);
      });
      
      currentIndex = index;
    }

    // Detect current slide based on scroll position
    function getCurrentSlideIndex() {
      if (!mainImageContainer) return 0;
      const scrollLeft = mainImageContainer.scrollLeft;
      const slideWidth = mainImageContainer.offsetWidth;
      return Math.round(scrollLeft / slideWidth);
    }

    // Update indicators on scroll
    if (mainImageContainer) {
      let scrollTimeout;
      mainImageContainer.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          const index = getCurrentSlideIndex();
          updateActiveStates(index);
        }, 50);
      }, { passive: true });
    }

    // Thumbnail clicks
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', function() {
        scrollToImage(index);
      });
    });

    // Indicator clicks
    indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', function() {
        scrollToImage(index);
      });
    });

    // Initialize first slide as active
    updateActiveStates(0);

    // Mouse drag support for desktop
    if (mainImageContainer) {
      let isDown = false;
      let startX;
      let scrollLeft;

      mainImageContainer.addEventListener('mousedown', (e) => {
        isDown = true;
        mainImageContainer.style.cursor = 'grabbing';
        mainImageContainer.style.userSelect = 'none';
        startX = e.pageX - mainImageContainer.offsetLeft;
        scrollLeft = mainImageContainer.scrollLeft;
      });

      mainImageContainer.addEventListener('mouseleave', () => {
        isDown = false;
        mainImageContainer.style.cursor = 'grab';
      });

      mainImageContainer.addEventListener('mouseup', () => {
        isDown = false;
        mainImageContainer.style.cursor = 'grab';
      });

      mainImageContainer.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - mainImageContainer.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        mainImageContainer.scrollLeft = scrollLeft - walk;
      });

      // Set cursor style
      mainImageContainer.style.cursor = 'grab';
    }

    // Quantity controls
    const qtyButtons = document.querySelectorAll('.darich-qty-btn');
    const qtyInput = document.getElementById('quantity');

    qtyButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        let qty = parseInt(qtyInput.value);
        if (this.dataset.action === 'increase') {
          qty++;
        } else if (this.dataset.action === 'decrease' && qty > 1) {
          qty--;
        }
        qtyInput.value = qty;
      });
    });

    // Variant selection with image updates
    const variantRadios = document.querySelectorAll('.darich-product__variants input[type="radio"]');
    const variantSelect = document.getElementById('variant-select');
    const optionLabels = document.querySelectorAll('.darich-product__option-value');
    const form = document.getElementById('product-form');

    variantRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        // Update the shown value
        const optionIndex = this.closest('.darich-product__option').querySelector('.darich-product__option-value').dataset.option;
        const valueDisplay = document.querySelector(`[data-option="${optionIndex}"]`);
        if (valueDisplay) {
          valueDisplay.textContent = this.value;
        }
        
        updateSelectedVariant();
      });
    });

    function updateSelectedVariant() {
      const selectedOptions = {};
      
      // Collect selected options
      document.querySelectorAll('.darich-product__option').forEach((optionDiv, index) => {
        const checkedRadio = optionDiv.querySelector('input[type="radio"]:checked');
        if (checkedRadio) {
          selectedOptions[index] = checkedRadio.value;
        }
      });
      
      // Find matching variant
      const matchingVariant = PRODUCT_DATA.variants.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });

      if (matchingVariant) {
        // Update variant select
        variantSelect.value = matchingVariant.id;
        
        // Update variant image if it exists
        if (matchingVariant.featured_media) {
          const mediaId = matchingVariant.featured_media.id;
          const slideIndex = Array.from(imageSlides).findIndex(slide =>
            parseInt(slide.dataset.mediaId) === mediaId
          );
          
          if (slideIndex !== -1) {
            scrollToImage(slideIndex);
          }
        }
        
        // Update availability and button
        const addToCartBtn = form.querySelector('.darich-product__add-to-cart');
        const availabilityDiv = form.querySelector('.darich-product__availability');
        
        if (matchingVariant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'ADD TO BAG';
          if (availabilityDiv) {
            availabilityDiv.innerHTML = '<span class="darich-product__availability--in-stock">✓ 在庫あり</span>';
          }
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'SOLD OUT';
          if (availabilityDiv) {
            availabilityDiv.innerHTML = '<span class="darich-product__availability--out">✕ 在庫切れ</span>';
          }
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
